export const isStarterAccount = (): boolean => {
  // @ts-ignore
  const clonedFrom = global?.me?.clonedFrom;
  // @ts-ignore
  console.log('isStarterAccount check:', {
    clonedFrom,
    isMatch: clonedFrom === 'paivcam-seed',
    // @ts-ignore
    globalMe: global?.me,
  });
  return clonedFrom === 'paivcam-seed';
};
